import 'css-chunksrc/client/pages/planzoneLogsPage/styles.scss';export default {
  "logs": "_logs_8u75q_1",
  "header": "_header_8u75q_7",
  "title": "_title_8u75q_16",
  "profileNavigation": "_profileNavigation_8u75q_20",
  "main": "_main_8u75q_28",
  "toolbar": "_toolbar_8u75q_35"
};